/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatementResponse } from '../../models/statement-response';

export interface GetProductRegistrationStatement$Params {
}

export function getProductRegistrationStatement(http: HttpClient, rootUrl: string, params?: GetProductRegistrationStatement$Params, context?: HttpContext): Observable<StrictHttpResponse<StatementResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductRegistrationStatement.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatementResponse>;
    })
  );
}

getProductRegistrationStatement.PATH = '/statements/actual';
